import { parsePhoneNumberFromString, type CountryCode } from 'libphonenumber-js/min'

// Phone numbers are stored in E.164 (+358401234567): one canonical form
// that sorts, dedupes and dials the same everywhere, and from which the
// country and the national formatting are derived. Members' numbers were
// typed freely before this, so a bare national number is read as one of
// `defaultCountry` (the club is Finnish).
export const DEFAULT_PHONE_COUNTRY: CountryCode = 'FI'

// E.164 when `raw` is a valid number, otherwise `raw` trimmed and left
// alone -- never throw away what a member typed because it did not parse.
export function normalisePhone(raw: string, defaultCountry: CountryCode = DEFAULT_PHONE_COUNTRY): string {
  const trimmed = raw.trim()
  if (!trimmed) return ''
  const parsed = parsePhoneNumberFromString(trimmed, defaultCountry)
  return parsed?.isValid() ? parsed.number : trimmed
}

// "+358 40 1234567"-style display; unparseable input comes back as is.
export function formatPhone(raw: string | null | undefined, defaultCountry: CountryCode = DEFAULT_PHONE_COUNTRY): string {
  if (!raw) return ''
  const parsed = parsePhoneNumberFromString(raw, defaultCountry)
  return parsed?.isValid() ? parsed.formatInternational() : raw
}

export function isValidPhone(raw: string, defaultCountry: CountryCode = DEFAULT_PHONE_COUNTRY): boolean {
  return parsePhoneNumberFromString(raw, defaultCountry)?.isValid() ?? false
}
